import React from 'react'
import MaintenanceLogo from '../components/shared/Logo'

const MaintenanceIcon = (
  <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="340 -323.5 739.9 706.5">
    <g id="paper">
      <path fill="#ecf1f8" d="M569-186.1h304.1v403.7H569z" />
      <path
        fill="#231f20"
        d="M869.1-182.1v395.7H573v-395.7h296.1m4-4H569v403.7h304.1v-403.7z"
      />
      <path fill="#ecf1f8" d="M549.4-165.9h304.1v403.7H549.4z" />
      <path
        fill="#231f20"
        d="M849.6-161.9v395.7H553.4v-395.7h296.2m4-4H549.4v403.7h304.1l.1-403.7z"
      />
      <g>
        <path fill="#fff" d="M529.8-145.8h304.1v403.7H529.8z" />
        <path
          fill="#231f20"
          d="M829.9-141.8v395.7H533.8v-395.7h296.1m4-4H529.8v403.7h304.1v-403.7z"
        />
      </g>
    </g>
    <path fill="none" d="M691.7-105.8h-50" />
    <path fill="#231f20" d="M641.7-107.8h50v4h-50z" />
    <path fill="none" d="M681.7-96.2h-60" />
    <path fill="#231f20" d="M621.7-98.2h60v4h-60z" />
    <path fill="none" d="M751.7-96.2h-30.3" />
    <path fill="#231f20" d="M721.4-98.2h30.3v4h-30.3z" />
    <path fill="none" d="M711.7-96.2h-20" />
    <path fill="#231f20" d="M691.7-98.2h20v4h-20z" />
    <path fill="#4680ff" d="M773.7 216.4V177H790v39.4" />
    <path fill="#231f20" d="M792 216.4h-4V179h-12.3v37.4h-4V175H792z" />
    <path fill="#4680ff" d="M740.7 216.4V191h15v25.4" />
    <path fill="#231f20" d="M757.7 216.4h-4V193h-11v23.4h-4V189h19z" />
    <path fill="#4680ff" d="M709.7 216.4v-13.6h15v13.6" />
    <path fill="#231f20" d="M726.7 216.4h-4v-11.6h-11v11.6h-4v-15.6h19z" />
    <path fill="none" d="M661.7 205.2h-90" />
    <path fill="#231f20" d="M571.7 203.2h90v4h-90z" />
    <path fill="none" d="M631.7 215.8h-60" />
    <path fill="#231f20" d="M571.7 213.8h60v4h-60z" />
    <path fill="none" d="M671.7 215.8h-30" />
    <path fill="#231f20" d="M641.7 213.8h30v4h-30z" />
    <path fill="none" d="M641.7 195.2h-70" />
    <path fill="#231f20" d="M571.7 193.2h70v4h-70z" />
    <path fill="none" d="M681.6 195.2h-29.9" />
    <path
      fill="#231f20"
      d="M651.7 193.2h29.8v4h-29.8zM801.7 217.8h-108v-42.5h4v38.5h104z"
    />
    <path fill="none" d="M731.7-105.8h-30" />
    <path fill="#231f20" d="M701.7-107.8h30v4h-30z" />
    <path fill="none" d="M592.3 144.5h-20.5" />
    <path fill="#231f20" d="M571.8 142.5h20.4v4h-20.4z" />
    <path fill="none" d="M631.8 155.1h-60" />
    <path fill="#231f20" d="M571.8 153.1h60v4h-60z" />
    <path fill="none" d="M641.8 134.5h-70" />
    <path fill="#231f20" d="M571.8 132.5h70v4h-70z" />
    <path fill="none" d="M631.6 144.5h-29.9" />
    <path fill="#231f20" d="M601.7 142.5h29.8v4h-29.8zM695.7 153.7h106v4h-106z" />
    <path fill="#fff" d="M801.7 126.8v28.9H692.3l99.4-36.2z" />
    <path
      fill="#231f20"
      d="M803.7 157.7H680.9l111.2-40.5 11.7 8.6-.1 31.9zm-100.1-4h96.2v-25.8l-8.3-6.1-87.9 31.9z"
    />
    <path d="M806.7 35.9c0-9.8-1.1-19.3-3.3-28.5-12.9-55.3-62.5-96.5-121.8-96.5-51.7 0-96.1 31.4-115.1 76.1 0 .1 0 .1-.1.2-.1.2-.2.5-.3.7-6.1 14.8-9.5 31-9.5 48 0 69 56 125 125 125 69.2-.1 125.2-56 125.1-125z" />
    <circle fill="#fff" cx="682.1" cy="35.4" r="100" />
    <path
      fill="#231f20"
      d="M682.1 137.4c-56.2 0-102-45.8-102-102s45.8-102 102-102 102 45.8 102 102c0 56.3-45.7 102-102 102zm0-200c-54 0-98 44-98 98s44 98 98 98 98-44 98-98-43.9-98-98-98z"
    />
    <path
      fill="#fff"
      d="M571.6 35.4h-4c0-63.1 51.4-114.5 114.5-114.5v4c-60.9 0-110.5 49.6-110.5 110.5z"
    />
    <path transform="rotate(120 590.102 204.786)" d="M515.1 192.3h150v25h-150z" />
    <path
      fill="#fff"
      d="M680.3 150.4v-4c60.9 0 110.5-49.6 110.5-110.5h4c0 63.2-51.3 114.5-114.5 114.5z"
    />
    <path
      fill="#4680ff"
      d="M996.2-119.4l-12-6.4-14.3 11.7h-14.4l-13.7 8.8-14-3-13.3 5.9V-73h82z"
    />
    <path
      fill="#999"
      d="M997.7-71.9h-84.4v-31.3l14.4-6.4 13.9 3 13.6-8.8h14.3l14.6-11.9 13.3 7.1.3 48.3zm-82.1-2.3h79.7l-.3-44.5-10.7-5.7-14 11.5h-14.5L942-104l-14-3-12.3 5.4-.1 27.4z"
    />
    <path fill="#999" d="M913.3-71.8v-59.9h2.3v57.5l80.9-.5v2.3z" />
    <circle fill="#fff" cx="927.3" cy="-107.9" r="2.9" />
    <path
      fill="#999"
      d="M927.3-103.8c-2.3 0-4.1-1.8-4.1-4.1s1.8-4.1 4.1-4.1 4.1 1.8 4.1 4.1c0 2.2-1.8 4.1-4.1 4.1zm0-5.9c-1 0-1.8.8-1.8 1.8s.8 1.8 1.8 1.8 1.8-.8 1.8-1.8-.8-1.8-1.8-1.8z"
    />
    <circle fill="#fff" cx="955.5" cy="-114.1" r="2.9" />
    <path
      fill="#999"
      d="M955.5-110c-2.3 0-4.1-1.8-4.1-4.1s1.8-4.1 4.1-4.1 4.1 1.8 4.1 4.1c0 2.2-1.9 4.1-4.1 4.1zm0-5.9c-1 0-1.8.8-1.8 1.8s.8 1.8 1.8 1.8 1.8-.8 1.8-1.8c-.1-1-.9-1.8-1.8-1.8z"
    />
    <circle fill="#fff" cx="984.1" cy="-125.8" r="2.9" />
    <path
      fill="#999"
      d="M984.1-121.7c-2.3 0-4.1-1.8-4.1-4.1s1.8-4.1 4.1-4.1 4.1 1.8 4.1 4.1-1.9 4.1-4.1 4.1zm0-5.9c-1 0-1.8.8-1.8 1.8s.8 1.8 1.8 1.8 1.8-.8 1.8-1.8-.8-1.8-1.8-1.8zM940.9-86.6h1.8v2.7h-1.8zM940.9-81.8h1.8v2.7h-1.8zM940.9-76.8h1.8v2.7h-1.8zM940.9-101.3h1.8v2.7h-1.8zM940.9-96.4h1.8v2.7h-1.8zM940.9-91.5h1.8v2.7h-1.8zM940.9-115.9h1.8v2.7h-1.8zM940.9-111.1h1.8v2.7h-1.8zM940.9-130.7h1.8v2.7h-1.8zM940.9-125.8h1.8v2.7h-1.8zM940.9-120.9h1.8v2.7h-1.8z"
    />
    <circle fill="#fff" cx="941.5" cy="-105" r="2.9" />
    <path
      fill="#999"
      d="M941.5-100.9c-2.3 0-4.1-1.8-4.1-4.1s1.8-4.1 4.1-4.1 4.1 1.8 4.1 4.1-1.8 4.1-4.1 4.1zm0-5.9c-1 0-1.8.8-1.8 1.8s.8 1.8 1.8 1.8 1.8-.8 1.8-1.8-.8-1.8-1.8-1.8zM967.8-87.2h1.8v2.7h-1.8zM967.8-82.3h1.8v2.7h-1.8zM967.8-77.4h1.8v2.7h-1.8zM967.8-101.9h1.8v2.7h-1.8zM967.8-97h1.8v2.7h-1.8zM967.8-92.1h1.8v2.7h-1.8zM967.8-111.7h1.8v2.7h-1.8zM967.8-106.8h1.8v2.7h-1.8zM967.8-131.3h1.8v2.7h-1.8zM967.8-126.3h1.8v2.7h-1.8zM967.8-121.5h1.8v2.7h-1.8z"
    />
    <circle fill="#fff" cx="969" cy="-114.1" r="2.9" />
    <path
      fill="#999"
      d="M969-110c-2.3 0-4.1-1.8-4.1-4.1s1.8-4.1 4.1-4.1 4.1 1.8 4.1 4.1c0 2.2-1.8 4.1-4.1 4.1zm0-5.9c-1 0-1.8.8-1.8 1.8s.8 1.8 1.8 1.8 1.8-.8 1.8-1.8-.8-1.8-1.8-1.8z"
    />
    <g>
      <circle fill="#999" cx="413.5" cy="-14.4" r="25" />
      <path
        fill="#fff"
        d="M408.9-16.2c-1.4 1.4-3.1 2.1-5.1 2.1s-3.7-.7-5.1-2.1c-1.4-1.4-2.1-3.1-2.1-5.1s.7-3.7 2.1-5.1 3.1-2.1 5.1-2.1 3.7.7 5.1 2.1 2.1 3.1 2.1 5.1c0 2-.7 3.7-2.1 5.1zm-3-2.9c.6-.6.9-1.3.9-2.2 0-.9-.3-1.6-.9-2.2s-1.3-.9-2.2-.9c-.9 0-1.6.3-2.2.9s-.9 1.3-.9 2.2c0 .9.3 1.6.9 2.2s1.3.9 2.2.9c.9 0 1.6-.3 2.2-.9zm13.7-9.6h3L406.8.4h-3l15.8-29.1zM427.8-2c-1.4 1.4-3.1 2.1-5.1 2.1S419-.6 417.6-2s-2.1-3.1-2.1-5.1.7-3.7 2.1-5.1 3.1-2.1 5.1-2.1 3.7.7 5.1 2.1c1.4 1.4 2.1 3.1 2.1 5.1.1 2-.6 3.7-2.1 5.1zm-2.9-7.3c-.6-.6-1.3-.9-2.2-.9s-1.6.3-2.2.9c-.6.6-.9 1.3-.9 2.2s.3 1.6.9 2.2c.6.6 1.3.9 2.2.9s1.6-.3 2.2-.9.9-1.3.9-2.2-.3-1.6-.9-2.2z"
      />
    </g>
    <g>
      <path
        fill="#4680ff"
        d="M709.2 307.8l-24.7 27.7v.4h37.6c-.1-11.2-5-21.2-12.9-28.1z"
      />
      <path fill="#999" d="M691.8 379.5c19.6-.7 35.3-16.5 36-36h-36v36z" />
      <path
        fill="#999"
        d="M684.5 298.6c-20.7 0-37.6 16.8-37.6 37.6 0 20.7 16.8 37.6 37.6 37.6.6 0 1.2 0 1.7-.1v-36.2H722v-1.4c.1-20.7-16.7-37.5-37.5-37.5zm-1.1 72.2c-18.6-.6-33.5-15.9-33.5-34.7 0-19.1 15.5-34.7 34.7-34.7 8.2 0 15.7 2.9 21.7 7.6l-22.9 25.5v36.3zm4-36.2l21.1-23.6c6.3 6 10.3 14.3 10.8 23.6h-31.9z"
      />
      <path
        fill="#999"
        d="M684.9 383c-.8 0-19.2-.1-33.1-13.7-13.9-13.6-13.4-32.4-13.4-33.2l2.9.1c0 .2-.4 18.4 12.6 31.1 13 12.7 30.8 12.9 31.1 12.9l-.1 2.8z"
      />
    </g>
    <path
      fill="#ff2651"
      d="M380.5 134.7v-4.5h-2.8c-.2-1-.6-1.9-1.1-2.7l1.9-1.9-3.2-3.2-1.9 1.9c-.8-.5-1.8-.9-2.7-1.1v-2.8h-4.5v2.8c-1 .2-1.9.6-2.7 1.1l-1.9-1.9-3.2 3.2 1.9 1.9c-.5.8-.9 1.8-1.1 2.7h-2.8v4.5h2.8c.2 1 .6 1.9 1.1 2.7l-1.9 1.9 3.2 3.2 1.9-1.9c.8.5 1.8.9 2.7 1.1v2.8h4.5v-2.7c1-.2 1.9-.6 2.7-1.1l1.9 1.9 3.2-3.2-1.9-1.9c.5-.8.9-1.8 1.1-2.7l2.8-.1z"
    />
    <path fill="#8dc63f" d="M506.3 76.1h-5.5v-5.5h-4v5.5h-5.5v4h5.5v5.5h4v-5.5h5.5z" />
    <path fill="#999" d="M524.6-157.8h-5.5v-5.5h-4v5.5h-5.5v4h5.5v5.5h4v-5.5h5.5z" />
    <g>
      <path
        fill="#999"
        d="M471.4 89.8v-7.4h-4.5c-.4-1.6-1-3.1-1.8-4.5l3.2-3.2-5.2-5.2-3.2 3.2c-1.4-.8-2.9-1.5-4.5-1.9v-4.5h-7.3v4.5c-1.6.4-3.1 1-4.5 1.9l-3.2-3.2-5.2 5.2 3.2 3.2c-.8 1.4-1.5 2.9-1.8 4.5h-4.5v7.4h4.5c.4 1.6 1 3.1 1.8 4.5l-3.2 3.2 5.2 5.2 3.2-3.2c1.4.8 2.9 1.5 4.5 1.9v4.5h7.3v-4.5c1.6-.4 3.1-1 4.5-1.9l3.2 3.2 5.2-5.2-3.2-3.2c.8-1.4 1.5-2.9 1.8-4.5h4.5zm-6.9-3l-.6 2.3c-.3 1.3-.8 2.5-1.5 3.6l-1.2 2 1.7 1.7 1.1 1.1-.9 1-1-1.1-1.7-1.7-2 1.2c-1.1.7-2.3 1.2-3.6 1.5l-2.3.6v3.9h-1.3V99l-2.3-.6c-1.3-.3-2.5-.8-3.6-1.5l-2-1.2-1.7 1.7-1 1.1-.9-1 1.1-1.1 1.7-1.7-1.2-2c-.7-1.1-1.2-2.3-1.5-3.6l-.6-2.3h-3.9v-1.4h3.9l.6-2.3c.3-1.3.8-2.5 1.5-3.6l1.2-2-1.7-1.7-1.1-1.1.9-1 1 1.1 1.7 1.7 2-1.2c1.1-.7 2.3-1.2 3.6-1.5l2.3-.6v-3.9h1.3v3.9l2.3.6c1.3.3 2.5.8 3.6 1.5l2 1.2 1.7-1.7 1-1.1.9 1-1.1 1.1-1.7 1.7 1.2 2c.7 1.1 1.2 2.3 1.5 3.6l.6 2.3h3.9v1.4h-3.9z"
      />
      <path
        fill="#999"
        d="M451.8 81.1c-2.7 0-4.9 2.2-4.9 4.9s2.2 4.9 4.9 4.9 4.9-2.2 4.9-4.9-2.2-4.9-4.9-4.9zm0 6.9c-1.1 0-1.9-.9-1.9-1.9 0-1.1.9-1.9 1.9-1.9 1.1 0 1.9.9 1.9 1.9s-.9 1.9-1.9 1.9z"
      />
    </g>
    <path
      id="diamond"
      transform="rotate(134.999 479.49 .487)"
      fill="#8dc63f"
      d="M474.3-4.7h10.4V5.7h-10.4z"
    />
    <circle fill="#999" cx="384.4" cy="35.5" r="5.1" />
    <circle fill="#ff2651" cx="345.1" cy="-3.8" r="5.1" />
    <path
      id="diamond_1_"
      transform="rotate(134.999 1072.496 70.7)"
      fill="#8dc63f"
      d="M1067.3 65.5h10.4v10.4h-10.4z"
    />
    <circle fill="#ff2651" cx="892.8" cy="236.7" r="5.1" />
    <circle fill="#ff2651" cx="1027.5" cy="-25.2" r="5.1" />
    <path
      id="diamond_3_"
      fill="#999"
      d="M901.4-46.3l2.4 2.4-2.4 2.4-2.4-2.4 2.4-2.4m0-4.9l-7.3 7.3 7.3 7.3 7.3-7.3-7.3-7.3z"
    />
    <g>
      <path
        fill="#999"
        d="M936.5 55v-4.5h-2.8c-.2-1-.6-1.9-1.1-2.7l1.9-1.9-3.2-3.2-1.9 1.9c-.8-.5-1.8-.9-2.7-1.1v-2.8h-4.5v2.8c-1 .2-1.9.6-2.7 1.1l-1.9-1.9-3.2 3.2 1.9 1.9c-.5.8-.9 1.8-1.1 2.7h-2.8V55h2.8c.2 1 .6 1.9 1.1 2.7l-1.9 1.9 3.2 3.2 1.9-1.9c.8.5 1.8.9 2.7 1.1v2.8h4.5V62c1-.2 1.9-.6 2.7-1.1l1.9 1.9 3.2-3.2-1.9-1.9c.5-.8.9-1.8 1.1-2.7h2.8z"
      />
      <circle fill="#999" cx="924.5" cy="52.8" r="2.6" />
    </g>
    <g display="none">
      <g display="inline">
        <path
          stroke="#231f20"
          strokeWidth="5"
          fill="none"
          strokeMiterlimit="10"
          d="M1047.8-164.9h-4"
        />
        <path
          strokeDasharray="8.0165,5.0103"
          stroke="#231f20"
          strokeWidth="5"
          fill="none"
          strokeMiterlimit="10"
          d="M1038.8-164.8c-12.5.1-38.4.3-79.2.3-60.5 0-57.5 49.5-57.5 49.5 0 35.7 31.2 50.1 55.3 52.1 24.2 2 42.6 26.8 42.6 52.4s-19 48.6-74.5 47.7c-38.5-.1-461.5-1.8-470.4-1.8s-53.6 4.8-53.6 50.7 41.5 47.5 55.3 50.2c13.8 2.7 44.6 16.6 42.7 50.5-2 33.9-23.8 50.2-57.4 50-26.6-.1-66.8-.1-82.5 0"
        />
        <path
          stroke="#231f20"
          strokeWidth="5"
          fill="none"
          strokeMiterlimit="10"
          d="M357.1 236.7h-4"
        />
      </g>
    </g>
    <circle fill="#999" cx="985.9" cy="69.9" r="17.1" />
    <g>
      <path fill="#4680ff" d="M954.4-17.1h-29.9C925-1 938.2 12 954.4 12v-29.1z" />
      <path
        fill="#999"
        d="M950.4-13.1V7.6c-5.3-.8-10.2-3.2-14.1-7-3.9-3.8-6.4-8.5-7.4-13.7h21.5m4-4h-29.9C925-1 938.2 12 954.4 12v-29.1z"
      />
    </g>
    <g>
      <path
        fill="#999"
        d="M685.5-323.5c.9 0 21.5.2 37 15.3 15.6 15.2 15 36.3 15 37.2l-3.2-.1c0-.2.5-20.6-14.1-34.8-14.5-14.2-34.4-14.4-34.7-14.4v-3.2z"
      />
      <g id="clock">
        <circle fill="#4680ff" cx="683.8" cy="-270.8" r="42" />
        <circle fill="#fff" cx="684.2" cy="-270.4" r="29" />
        <path
          fill="#231f20"
          d="M683.8-309.6c21.3 0 38.8 17.4 38.8 38.8S705.2-232 683.8-232 645-249.3 645-270.8s17.5-38.8 38.8-38.8m0-3.2c-23.2 0-42 18.8-42 42s18.8 42 42 42 42-18.8 42-42-18.8-42-42-42z"
        />
        <path
          fill="#231f20"
          d="M683.8-298.1c15 0 27.3 12.2 27.3 27.3 0 15.1-12.2 27.3-27.3 27.3-15 0-27.3-12.2-27.3-27.3 0-15.1 12.3-27.3 27.3-27.3m0-3.2c-16.8 0-30.5 13.7-30.5 30.5s13.7 30.5 30.5 30.5 30.5-13.7 30.5-30.5-13.6-30.5-30.5-30.5z"
        />
        <path
          stroke="#999"
          strokeWidth="4"
          fill="none"
          strokeMiterlimit="10"
          d="M683.8-285.3l.2 14.7 18.4 10.8"
        />
        <circle fill="#999" cx="683.8" cy="-292.6" r="1.6" />
        <circle fill="#999" cx="683.8" cy="-248.9" r="1.6" />
        <circle fill="#999" cx="662" cy="-270.8" r="1.6" />
        <circle fill="#999" cx="705.7" cy="-270.8" r="1.6" />
      </g>
      <path
        fill="#999"
        d="M683.8-309.6c21.3 0 38.8 17.4 38.8 38.8S705.2-232 683.8-232 645-249.3 645-270.8s17.5-38.8 38.8-38.8m0-3.2c-23.2 0-42 18.8-42 42s18.8 42 42 42 42-18.8 42-42-18.8-42-42-42z"
      />
      <path
        fill="#999"
        d="M683.8-298.1c15 0 27.3 12.2 27.3 27.3 0 15.1-12.2 27.3-27.3 27.3-15 0-27.3-12.2-27.3-27.3 0-15.1 12.3-27.3 27.3-27.3m0-3.2c-16.8 0-30.5 13.7-30.5 30.5s13.7 30.5 30.5 30.5 30.5-13.7 30.5-30.5-13.6-30.5-30.5-30.5z"
      />
    </g>
    <g>
      <path
        fill="#4680ff"
        d="M953.8 162.5l.3-27.1c-26 .4-47 21.1-48 46.9h27.5c1-10.6 9.6-19 20.2-19.8z"
      />
      <path
        fill="#999"
        d="M997.1 165.3c2.6 6 4 12.3 4 18.9 0 25.5-20.8 46.3-46.3 46.3-7 0-13.9-1.6-20.2-4.6l11.6-18.3c3 1.2 6.2 1.8 9.4 1.8 13.6 0 24.8-11.1 24.8-24.8 0-3-.6-6-1.6-8.7l18.3-10.6m1.2-3.5l-22.6 13c1.4 3 2.3 6.3 2.3 9.8 0 12.3-10 22.2-22.2 22.2-3.7 0-7.2-.9-10.3-2.5l-14.2 22.5c7 3.9 15.1 6.2 23.8 6.2 27 0 48.8-21.9 48.8-48.8-.2-8.1-2.2-15.7-5.6-22.4zM951.6 138l-.3 22.2c-10 1.8-18 9.6-19.9 19.5h-22.6c2.1-22.4 20.2-40.1 42.8-41.7m2.5-2.6c-26 .4-47 21.1-48 46.9h27.5c1.1-10.6 9.6-18.9 20.2-19.8l.3-27.1z"
      />
      <path
        fill="#999"
        d="M955.1 201.3v-2.5c8 0 14.5-6.5 14.5-14.5s-6.5-14.5-14.5-14.5v-2.5c9.4 0 17 7.6 17 17s-7.6 17-17 17z"
      />
      <path
        fill="#ecf1f8"
        d="M958.2 161c6.4.9 12.1 4.3 15.8 9.3l20.5-11.9c-7.9-12-21.1-20.1-36.3-21.1V161z"
      />
      <path
        fill="#999"
        d="M931.7 187.2H908c.9 14.9 8.7 27.9 20.2 35.9l11.9-20.5c-4.5-3.8-7.6-9.2-8.4-15.4z"
      />
    </g>
    <g>
      <g id="globe">
        <path
          fill="#999"
          d="M459.5-136.1c-19.7 0-35.6 16-35.6 35.6s16 35.6 35.6 35.6 35.6-16 35.6-35.6-15.9-35.6-35.6-35.6zm24.6 57.8c-1.3-1.2-3.6-3.1-6.8-5 2.1-4.6 3.6-10 3.6-16.3 0-6.6-1.6-12.3-3.9-17.2 3.7-2.1 6.2-4.3 7.5-5.5 5.1 5.8 8.3 13.4 8.3 21.8-.1 8.6-3.4 16.3-8.7 22.2zM460.8-88v-24.5c5.6-.1 10.3-1.5 14.1-3.2 2.1 4.6 3.6 10 3.6 16.1 0 5.9-1.3 10.9-3.4 15.2-3.8-1.9-8.6-3.4-14.3-3.6zm13.2 5.8c-4.2 7.6-10.3 12.4-13.3 14.4v-17.8c5.3.2 9.7 1.7 13.3 3.4zm-13.2-32.7v-18c2.9 2.3 8.8 7.3 13 15-3.6 1.6-8 2.9-13 3zm3.3-18.4c7.2 1 13.7 4.3 18.6 9.2-1 1-3.4 3.2-6.9 5.1-3.5-6.7-8.4-11.5-11.7-14.3zm-20.6 13.6c-3.5-2.1-5.8-4.2-6.6-5 4.9-4.6 11.1-7.7 18-8.7-3.2 2.8-7.8 7.4-11.4 13.7zm14.8-13.2v18c-5-.3-9.2-1.8-12.7-3.5 4.2-7.4 9.9-12.3 12.7-14.5zm-13.9 16.6c3.7 1.9 8.4 3.4 13.8 3.8V-88c-5.8.2-10.6 1.8-14.4 3.8-2-4.3-3.4-9.4-3.4-15.3.1-6.5 1.7-12.1 4-16.8zm13.9 30.7v17.8c-2.9-2-9-6.7-13.3-14.3 3.5-1.8 8-3.3 13.3-3.5zm-4.1 17.8c-6.6-1.1-12.5-4.1-17.2-8.4.9-.9 2.9-2.8 6-4.6 3.3 6 7.8 10.3 11.2 13zm22-13.2c2.9 1.7 5 3.4 6.2 4.5-4.7 4.5-10.8 7.6-17.5 8.7 3.3-2.7 7.9-7.1 11.3-13.2zm-49.8-19.5c0-8.7 3.4-16.5 8.8-22.4 1 1 3.4 3.2 7.2 5.5-2.5 5-4.2 11-4.2 17.9 0 6.4 1.5 11.9 3.7 16.5-3.4 2-5.6 4.2-6.5 5.1-5.7-6-9-13.9-9-22.6z"
        />
        <path
          fill="#999"
          d="M412.8-100.6c-.1-.7-1.7-17.9 13.6-33.1 15.3-15.3 32.9-14.2 33.7-14.1l-.2 2.4c-.2 0-17.4-1-31.8 13.4s-12.9 31-12.9 31.2l-2.4.2z"
        />
      </g>
      <g id="redArrow">
        <path
          fill="#ff2651"
          d="M489.2-146.4c-2.8-1.7-6.1-2.6-9.4-2.6-10 0-18.1 8.1-18 18.1 0 3.3.9 6.5 2.6 9.4l1.7 2.4c3.4 4.9 13.8 19.1 13.8 19.1s10.4-14.2 13.8-19.1l1.7-2.4c5-8.6 2.4-19.7-6.2-24.9zm-9.4 24.5c-5 0-9-4.1-9-9s4.1-9 9-9c5 0 9 4 9 9 .1 4.9-3.9 9-9 9z"
        />
        <path
          fill="#999"
          d="M496.3-140.9c-5.5-9.1-17.4-12-26.5-6.5-9.1 5.5-12 17.4-6.5 26.5.2.4.7 1.2 1.7 2.5 3.3 4.9 13.8 18.9 13.8 19.1l1 1.3 1-1.3c.1-.1 10.5-14.2 13.8-19.1.9-1.4 1.4-2.1 1.7-2.5 3.8-6.2 3.8-13.9 0-20zm-2.1 18.7l-.2.2c-.2.2-.6.9-1.5 2.1-2.7 4-10.1 14-12.8 17.7-2.7-3.6-10.1-13.8-12.8-17.7-.9-1.3-1.3-1.9-1.5-2.1l-.2-.2c-3.2-5.4-3.2-12.1 0-17.5 4.8-7.9 15.2-10.5 23.1-5.7 7.9 4.8 10.7 15.3 5.9 23.2z"
        />
        <path
          fill="#ddd"
          d="M479.9-141.3c-5.7 0-10.3 4.6-10.3 10.2 0 5.7 4.6 10.3 10.2 10.3 5.7 0 10.3-4.6 10.3-10.3 0-5.5-4.6-10.1-10.2-10.2zm0 18.1c-4.3 0-7.8-3.5-7.8-7.8s3.5-7.8 7.8-7.8 7.8 3.5 7.8 7.8c0 4.4-3.5 7.8-7.8 7.8z"
        />
      </g>
    </g>
    <g>
      <path
        fill="#999"
        d="M686.1-208.4h-4.5v7.9h4.5zM686.1-222.5h-4.5v7.9l4.5-.1zM686.1-194.2l-4.5.1v7.9l4.5-.1z"
      />
    </g>
    <g>
      <path
        fill="#027cb5"
        d="M743.5 37.8l-32.7-13.7-24.2 72.1c1.1-.4 2-.8 2.9-1.3l53.3-53.3c.4-1.3.6-2.6.7-3.8z"
      />
      <path
        fill="#4680ff"
        d="M741.3 29.5l-53.2-53.2c-.3-.1-.7-.3-1-.4l23.6 42.9 31.8 13.5c-.3-1-.7-1.9-1.2-2.8z"
      />
      <path
        fill="#0688bc"
        d="M620.6 38.4c.1 1.2.4 2.4.8 3.6l53 53c2.1 1.3 4.3 1.9 6.3 2l24.5-73-84.6 14.4z"
      />
      <path
        fill="#89b0f7"
        d="M621.2 33l83.9-14.3-23.7-44c-1.8 0-3.6.4-5.5 1.3l-52.8 52.8c-.7 1.2-1.4 2.6-1.9 4.2z"
      />
    </g>
    <g>
      <path fill="#999" d="M409.2 199.4v-59.9h2.3V197l80.8-.6.1 2.4z" />
      <path fill="#4680ff" d="M419.2 176.9h8.2v20h-8.2z" />
      <circle fill="#fff" cx="423.3" cy="176.9" r="2.9" />
      <path
        fill="#999"
        d="M423.3 181c-2.3 0-4.1-1.8-4.1-4.1s1.8-4.1 4.1-4.1 4.1 1.8 4.1 4.1-1.9 4.1-4.1 4.1zm0-5.8c-1 0-1.8.8-1.8 1.8s.8 1.8 1.8 1.8 1.8-.8 1.8-1.8c0-1.1-.9-1.8-1.8-1.8z"
      />
      <path fill="#4680ff" d="M437.6 151.1h8.2v45.8h-8.2z" />
      <circle fill="#fff" cx="441.7" cy="151.1" r="2.9" />
      <path
        fill="#999"
        d="M441.7 155.2c-2.3 0-4.1-1.8-4.1-4.1s1.8-4.1 4.1-4.1 4.1 1.8 4.1 4.1c0 2.2-1.9 4.1-4.1 4.1zm0-5.9c-1 0-1.8.8-1.8 1.8s.8 1.8 1.8 1.8 1.8-.8 1.8-1.8-.9-1.8-1.8-1.8z"
      />
      <path fill="#4680ff" d="M456 161.1h8.2v35.8H456z" />
      <circle fill="#fff" cx="460.1" cy="161.1" r="2.9" />
      <path
        fill="#999"
        d="M460.1 165.2c-2.3 0-4.1-1.8-4.1-4.1s1.8-4.1 4.1-4.1 4.1 1.8 4.1 4.1-1.9 4.1-4.1 4.1zm0-5.8c-1 0-1.8.8-1.8 1.8s.8 1.8 1.8 1.8 1.8-.8 1.8-1.8-.9-1.8-1.8-1.8z"
      />
      <path fill="#4680ff" d="M474.4 184.6h8.2v12.3h-8.2z" />
      <g>
        <circle fill="#fff" cx="478.5" cy="184.6" r="2.9" />
        <path
          fill="#999"
          d="M478.5 188.7c-2.3 0-4.1-1.8-4.1-4.1s1.8-4.1 4.1-4.1 4.1 1.8 4.1 4.1-1.9 4.1-4.1 4.1zm0-5.9c-1 0-1.8.8-1.8 1.8s.8 1.8 1.8 1.8 1.8-.8 1.8-1.8c-.1-1-.9-1.8-1.8-1.8z"
        />
      </g>
    </g>
    <g>
      <path
        fill="#999"
        d="M686.1 271.9h-4.5v7.9h4.5zM686.1 257.8h-4.5v7.9l4.5-.1zM686.1 286.1l-4.5.1v7.9l4.5-.1z"
      />
    </g>
    <g>
      <path
        fill="#999"
        d="M515.5 148.2l-2.3-3.9-6.8 3.9 2.3 3.9zM527.7 141.1l-2.2-3.9-6.9 4 2.4 3.8zM503.2 155.3l-2.3-3.9-6.9 4 2.4 3.8z"
      />
    </g>
    <g>
      <path
        fill="#999"
        d="M896.9-71.8l-2.3-3.9-6.8 4 2.3 3.9zM909.1-78.8l-2.2-3.9-6.9 3.9 2.4 3.9zM884.6-64.7l-2.3-3.8-6.9 3.9 2.4 3.9z"
      />
    </g>
    <g>
      <path
        fill="#999"
        d="M894.3 152.2l2.3-3.9-6.9-3.9-2.2 3.9zM906.5 159.3l2.3-3.9-6.9-4-2.1 4zM882 145.1l2.2-3.9-6.9-4-2.1 4z"
      />
    </g>
    <g>
      <path
        fill="#999"
        d="M513.7-68.5l2.2-3.9-6.8-3.9-2.3 3.9zM525.9-61.4l2.2-3.9-6.8-4-2.2 4zM501.4-75.6l2.1-3.9-6.8-4-2.2 4z"
      />
    </g>
    <g>
      <path
        fill="#9ac255"
        d="M916.3-183.9v-4.5h-2.8c-.2-1-.6-1.9-1.1-2.7l1.9-1.9-3.2-3.2-1.9 1.9c-.8-.5-1.8-.9-2.7-1.1v-2.8H902v2.8c-1 .2-1.9.6-2.7 1.1l-1.9-1.9-3.2 3.2 1.9 1.9c-.5.8-.9 1.8-1.1 2.7h-2.8v4.5h2.8c.2 1 .6 1.9 1.1 2.7l-1.9 1.9 3.2 3.2 1.9-1.9c.8.5 1.8.9 2.7 1.1v2.8h4.5v-2.8c1-.2 1.9-.6 2.7-1.1l1.9 1.9 3.2-3.2-1.9-1.9c.5-.8.9-1.8 1.1-2.7h2.8z"
      />
      <circle fill="#9ac255" cx="904.3" cy="-186.1" r="2.6" />
    </g>
    <circle fill="#ff2651" cx="481.4" cy="294.1" r="5.1" />
  </svg>
)
function siteMaintenance() {
  return (
    <section>
      <div className="maintenanceLogoContainer">
        <div className="maintenanceLogo">
          <MaintenanceLogo />
        </div>
        <h1 className="maintenanceLogoText">Owner&apos;s Edge</h1>
      </div>
      <section className="maintenanceCenteredItem">
        <div className="maintenanceContent">
          <div className="maintenanceIcon">{MaintenanceIcon}</div>
          <div className="maintenanceInfo">
            <h1>Site Maintenance</h1>
            <p>
              Owner's Edge is currently down for some scheduled site maintenance. We are
              sorry for any inconvience, we will be up and running shortly. Please contact
              your underwriter for further details.
              <br /> Thank you for your patience!
            </p>
          </div>
        </div>
      </section>
    </section>
  )
}

export default siteMaintenance
